import {Algorithm} from "./Algorithm";
import {UserInputSliderSelector} from "./UserInputSliderSelector";

export class Maestro extends Algorithm {

  constructor(container) {
    super(container);

    this.weatherOverrides = {
      key: {
        A: "rainy",
        B: "rainy",
        C: "cloudy",
        D: "cloudy",
        E: "foggy",
        F: "foggy",
        G: "stormy",
        H: "stormy",
        I: "sunny",
        J: "sunny",
      }
    };
  }

  buildRangesMap() {
    this.rangesMap = this.userCombinationData.map(({key, title}, index) => {
      const [min, max] = title.match(/\d+/g).map(Number); // extract numbers from the title
      return {key, min, max, index};
    });
  }

  initUserInputs() {
    super.initUserInputs();

    this.outdoorTemperatureSelector = new UserInputSliderSelector(
      this.$container.find(`.user-input-selector-container[data-user-input-id="temperature"]`),
      this.rangesMap.map(({min, max}) => Math.floor((min + max) / 2))
    );
    this.outdoorTemperatureSelector.on("userInputValueChanged", (value) => this.onUserInput(value));
  }

  onUserInput(value) {
    const targetCombination = this.findUserCombination(value);

    // Update KPIs
    this.selectKPIs(targetCombination.key);

    // Update charts
    Object.entries(this.charts).forEach(([name, chart]) => {
      chart.loadDataset(targetCombination.index);
    });

    this.decisionLogs.update(this.currentKPIKey, this.buildingSelector.currentBuilding);

    this.sendWeatherOverride();
  }

  sendWeatherOverride() {
    if (!this.isActive) return;

    const targetCombination = this.findUserCombination(this.outdoorTemperatureSelector.currentValue);

    app.sendScreenBridgeMessage(`weatherOverride ${this.weatherOverrides.key[targetCombination.key] ?? "none"}`);
  }

  start() {
    super.start();

    this.sendWeatherOverride();
  }

  findUserCombination(value) {
    // Let's return the entry where the value fits in the correct range
    // If there is no entry, fallback to the last one (happens when the value is equal to the max
    return this.rangesMap.find(({min, max}) => value >= min && value < max)
      ?? this.rangesMap[this.rangesMap.length - 1];
  }

  resetUserInputs() {
    this.outdoorTemperatureSelector.reset();
  }

}
